// extracted by mini-css-extract-plugin
module.exports = {"site-layout-background":"session-template_site-layout-background__2qyak","session-template-body":"session-template_session-template-body__2PRDS"};